/**
 * Avalara © 2018
 * file: engines/opus_ui/src/search/ObligationLink.js
 */

import React from 'react';

const getLink = (data) =>
  `/#/search?query=items:${data.itemId}&facet="Obligations"`;

const ObligationLink = ({ data, type }) => {
  return (
    <div className="Summary">
      <div className="SummaryTitle">
        <a href={getLink(data)}>
          <div className="Type">Obligation</div>
          <div className="Value">{data.featureName}</div>
        </a>
      </div>
      <div className="SummaryLink">
        <a href={getLink(data)}>{getLink(data)}</a>
      </div>
      <div className="SummaryData">
        <p>
          Customer:{' '}
          {data.customer && data.customer.name
            ? data.customer.name
            : 'No customer associated with this transaction'}
        </p>
      </div>
    </div>
  );
};

export default ObligationLink;
